module.exports = __webpack_public_path__ + "img/Logo PNG.20977c97.png";